<template>
  <ion-page>
    <ion-content class="white">
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">メール送信完了</ion-header>
      <div class="ion-padding">
        <div class="ion-padding-horizontal">
          <ion-label>ご登録のメールアドレスに、認証コード通知メールを送信しました。</ion-label>
          <br/>
          <ion-label>メールが届きましたら、「メール認証に進む」ボタンを押してください。</ion-label>
          <br/>
          <br/>
          <ion-label id="annotation">※メールが届かない場合は、メール受信設定及び入力されたメールアドレスにお間違いがないか、ご確認ください。</ion-label>
          <br/><br/>
          <ion-label id="annotation">※ドメイン指定されている場合は、「info.kutsu.com」と「chiyodagrp.co.jp」からのメールが受信できるよう、受信設定してください。</ion-label>
          <ion-button class="ion-margin-top primary-button" expand="block" @click="toEmailValify">メール認証に進む ></ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonHeader,
  IonContent,
  IonIcon,
} from "@ionic/vue";
import { information } from 'ionicons/icons';

import { useRoute, useRouter } from 'vue-router';

const router = useRouter()
const route = useRoute()

function toEmailValify() {
  router.push({name: 'CodeVerifyOfForgotPassword', query: {email: route.query.email}})
}
</script>

<style scoped>
#annotation {
  font-size: 0.75rem;
}
</style>